<template>
  <div class="content">
    <div class="title">用户列表</div>
    <Search class="search" :searchForm="searchForm" :searchList="searchList" :options-type="optionsType" :exportLoading="exportLoading"></Search>
    <!--    表格-->
    <el-table class="table" v-loading="searchForm.Loading" :data="tableList.list" border fit highlight-current-row
      style="width: 100%;" header-row-class-name="header">
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column v-for="(item, index) in tableData" :key="index" :prop="item.value" :label="item.text"
        align="center" :sortable="['balance', 'orderCount'].includes(item.value) ? true : false">
        <template slot-scope="{row}">
          <el-switch v-if="item.value === 'status'" v-model="row[item.value]" @change="getStatus($event, row)"
            :active-value="1" :inactive-value="0">
          </el-switch>
          <div class="text" v-if="item.value === 'nickName'" @click="getDetail(row)" style="cursor: pointer">
            <img v-if="row.headPic" :src="row.headPic" class="header"/>
            <img v-else src="../../../../assets/img/icon_header_default.png" class="header"/>
            <div>
              {{ row[item.value] }}
              <div class="table-id">({{ row.id }})</div>
            </div>
          </div>
          <span :class="item.value ==='referCount'?'parentIdClass':''" v-if="item.value !== 'status' && item.value !== 'nickName' && item.value !== 'orderCount'" @click="handleClick(item.value,row)">{{row[item.value] }}</span>
          <span style="cursor: pointer" v-if="item.value == 'orderCount'" @click="goOrder(row)">{{ row[item.value] }}</span>
          <span style="cursor: pointer" v-if="row[item.value] === ''" >-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
<!--          <div class="add" @click="setMajor(row)" v-if="!row.isMajor && row.openProfitPackage == 1">设为总监</div>-->
          <div class="delete" @click="setMajor(row)" v-if="row.isMajor == 1 && row.openProfitPackage == 1">取消总监</div>
          <div class="add" style="margin-top: 10px" @click="getDetail(row)">查看详细信息</div>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination v-if="tableList.total > 0" class="pagination" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableList.total">
    </el-pagination>
    <el-dialog title="设为总监" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="dialog">
        <div class="dialog-text" v-if="!this.isMajor" style="text-align: left">设为总监后，其邀请的下级好友均能享受佣金分成。总监分成比例在"基础设置-推广设置"页面填写。<div>确定设置为总监？</div></div>
        <div class="dialog-text" v-else>取消总监身份后，该用户将不再享受分红。 是否取消该用户总监身份？</div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisible = false">取消</div>
          <div class="button-success" @click="confirm">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="用户信息" :visible.sync="userShow" width="30%" :before-close="handleClose">
      <div class="dialog">
        <div class="dialog-text">用户ID：{{ detail.id }}</div>
        <div class="dialog-text">注册时间：{{ detail.createTime }}</div>
        <div class="dialog-text">推荐人ID：{{ detail.parentId }}</div>
        <div class="dialog-text">支付宝账号：{{ detail.alipay }}</div>
        <div class="dialog-text">可用金额：{{ detail.balance }}</div>
        <div class="dialog-text">是否总监：{{ detail.isMajor ? '是' : '否' }}</div>
        <div class="dialog-button">
          <div class="button-cancel" @click="userShow = false">取消</div>
          <div class="button-success" @click="userShow = false">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini()
export default {
  components: {
    Search
  },
  name: "index",
  data() {
    return {
      exportLoading: false,
      searchForm: {
        number: '',
        phone: '',
        createTime: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        Loading: true,
        parentId: '', // 推荐人ID
        appKey: localStorage.getItem('appKeyMini')
      },
      searchList: [
        {
          id: 'id',
          text: '用户ID',
          placeholder: '请输入用户ID',
          type: 'input',
        },{
          id: 'parentId',
          text: '推荐人ID',
          placeholder: '请输入推荐人ID',
          type: 'input'
        }, {
          id: 'phone',
          text: '用户手机号',
          placeholder: '请输入用户手机号',
          type: 'input',
        }, {
          id: 'createTime',
          text: '注册时间',
          placeholder: '',
          type: 'time'
        }],
      // 表头
      tableData: [{
        text: '用户',
        value: 'nickName',
      }, {
        text: '用户身份',
        value: 'identity',
      }, {
        text: '推荐人ID',
        value: 'parentId',
      }, {
        text: '手机号',
        value: 'phone',
      }, {
        text: '账户余额',
        value: 'balance',
      }, {
        text: '下单数量',
        value: 'orderCount',
      }, {
        text: '邀请用户数',
        value: 'referCount',
      }, {
        text: '累计总佣金(元)',
        value: 'totalBalance',
      }, {
        text: '启用/禁用登录',
        value: 'status',
      }, {
        text: '注册时间',
        value: 'createTime',
      }
      ],
      tableList: [], // 表单数据
      currentPage: 1, // 页码
      dialogVisible: false, // 设置总监弹窗
      userShow: false, // 详情弹窗
      detail: {}, //用户详情
      isMajor: '',// 是否是总监
      optionsType: [
        {
          label: '普通用户',
          value: 0
        },
        {
          label: '总监',
          value: 1
        }
      ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
      this.userShow = false
    },
    getList() {
      this.searchForm.Loading = true
      const result = Object.fromEntries(
        Object.entries(this.searchForm).map(([key, value]) => {
          if(key === 'phone') {
            value = value.replace(/\s+/g,'')
          }
          return [key, value];
        })
      );
      MiniModel.getMiniUserList(result).then(res => {
        if (res.data.code == 200) {
          this.tableList = res.data.data
          this.searchForm.Loading = false
        } else {
          this.$message.error(res.data.info)
          this.searchForm.Loading = false
        }
      })
    },
    // 查看详情
    getDetail(item) {
      // 防止点击复制时弹出详情
      if (window.getSelection().toString() === '') {
        let param = {
          fansId: item.id
        }
        MiniModel.getMiniUserDetail(param).then(res => {
          if (res.data.code == 200) {
            this.userShow = true
            this.detail = res.data.data
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
    },
    // 修改状态
    getStatus(e, item) {
      let param = {
        fansId: item.id,
        status: e
      }
      MiniModel.alterStatus(param).then(res => {
        if (res.data.code == 200) {
          this.$message.success('修改成功')
          this.getList()
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    // 序号
    indexMethod(index) {
      index = (index + 1) + (this.searchForm.pageNo - 1) * this.searchForm.pageSize
      return index
    },
    // 设置总监
    setMajor(item) {
      this.dialogVisible = true
      this.fansId = item.id
      this.isMajor = item.isMajor
    },
    // 设置总监
    confirm() {
      let param = {
        fansId: this.fansId
      }
      // 是否已经是总监
      if (this.isMajor) {
        MiniModel.cancelMajor(param).then(res => {
          if (res.data.code == 200) {
            this.$message.success('设置成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.info || res.data.message)
          }
        })
      } else {
        MiniModel.queryJunior(param).then(res => {
          if (res.data.code == 200) {
            console.log(res)
            if (res.data.data === 3) {
              this.$message.error('用户已有推荐人和下级，无法设置为总监')
            } else {
              MiniModel.updateMajor(param).then(res => {
                if (res.data.code == 200) {
                  this.$message.success('设置成功')
                  this.dialogVisible = false
                  this.getList()
                } else {
                  this.$message.error(res.data.info || res.data.message)
                }
              })
            }
          } else {
            this.$message.error(res.data.info || res.data.message)
          }
        })
      }
    },
    goOrder(row) {
      console.log(row)
      this.$router.push({
        path: '/pc/miniProgram/order',
        query: {
          name: row.nickName,
        }
      })
      this.$store.commit('nav/SET_ACTIVE_INDEX_MINI', 2)
    },
    // 导出
    exportButton() {
      this.exportLoading = true
      MiniModel.exportMovieUser(this.searchForm).then(async res => {
        const code = res.data.code
        const message = res.data.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
      }).finally(()=>{
        this.exportLoading = false
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
    // 处理点击
    handleClick(val,row){
      if(val === 'referCount'){
        this.searchForm.parentId = row.id
        this.getList()
      }
    }
  }
}
</script>

<style scoped lang="less">
.content {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  width: 100%;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
}

.table {
  margin-top: 10px;

  &-id {
  }
}

.dialog {
  //padding: 20px 80px;

  .dialog-title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }

  .dialog-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    text-align: left;
    div{
      margin-top: 20px;
    }
  }

  .dialog-button {
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;

    .button-success {
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .button-cancel {
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}

/deep/.el-table th,
.el-table tr {
  background-color: #FCFAF8;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #EEEEEE;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.add {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF8622;
  line-height: 18px;
  cursor: pointer;
}

.delete {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 18px;
  cursor: pointer;
}

.header {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  margin-right: 5px;
}

.search {
  margin-top: 30px;
}
.text{
  color: #3D9EFC;
  display: flex;
  align-items: center;
  text-decoration:underline
}
.parentIdClass{
  color: #3D9EFC;
  text-decoration:underline;
  font-weight: 600;
  cursor: pointer;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 25px !important;
}

/deep/.el-date-editor .el-range__icon {
  line-height: 25px !important;
}
/* chrome 73so.com */
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/* 火狐浏览器 */
/deep/input[type="number"]{
  -moz-appearance: textfield;
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/user/index.vue